/**
 * DetailMetadataItem component.
 */
import Container from '@components/atoms/container/detailCrewItemContainer';
import Title from '@components/atoms/container/detailItemTitleContainer';
import Value from '@components/atoms/container/detailItemValueContainer';

/**
 * Props for the DetailMetadataItem component.
 */
interface Props {
  title?: string;
  value?: string;
}

/**
 * Displays the detail metadata item.
 */
export default function DetailMetadataItem({ title, value }: Props) {
  return title && value ? (
    <Container id={'detailMetadataItem'}>
      <Title id={'detailMetadataItemTitle'}>{title}</Title>
      <Value id={'detailMetadataItemValue'}>{value}</Value>
    </Container>
  ) : null;
}
